import { loyaltyTeamSettingsSchema } from "@redotech/redo-model/loyalty/loyalty-definition";

export const updateLoyaltyPopupSettings = {
  name: "updateLoyaltyPopupSettings" as const,
  input: loyaltyTeamSettingsSchema.omit({ enabled: true }),
  output: loyaltyTeamSettingsSchema.omit({ enabled: true }),
};
